/* eslint-env browser */

module.exports = {
  trackEvent(label) {
    return function() {
      if (console) {
        console.log('analytics event: ', label)
      }
      if (window && window.gtag) {
        window.gtag('event', 'CLICKED', {
          event_category: 'BUTTON',
          event_label: label,
        })
      }
    }
  },
  trackEventSimple(eventName) {
    if (console) {
      console.log('analytics event simple: ', eventName)
    }
    if (window && window.gtag) {
      window.gtag('event', eventName)
    }
  },
  trackView(label) {
    return function() {
      if (console) {
        console.log('analytics view event: ', label)
      }
      if (window && window.gtag) {
        window.gtag('event', 'VIEW', {
          event_category: 'IMAGE',
          event_label: label,
        })
      }
    }
  },
}
